import { render, staticRenderFns } from "./SignupIframe.vue?vue&type=template&id=44215014&scoped=true"
import script from "./SignupIframe.js?vue&type=script&lang=js&external"
export * from "./SignupIframe.js?vue&type=script&lang=js&external"
import style0 from "./SignupIframe.scss?vue&type=style&index=0&id=44215014&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44215014",
  null
  
)

export default component.exports